<basket-view-expandable [expandableTitle]="'Have you got a promo code?'"
                        (onClose)="onClose()">
    <form #form="ngForm"
          method="POST">
        <form-mui-field [label]="('Enter offer code' | translate)">
            <input type="text"
                   [class._force-error]="forceError"
                   name="coupon"
                   [(ngModel)]="data.coupon"
                   (ngModelChange)="onInputChange()"
                   (keydown.enter)="submit()"
                   required />
        </form-mui-field>

        <result class="block m-t-2"
                [status]="status"></result>
        @if(coupons.length){
        <div class="flex-column flex-top">
            @for(couponCode of coupons; track $index){
            <div class="p-t-1 p-b-1 p-l-2 p-r-2 bg-col-3 flex flex-middle m-t-2"
                 style="border-radius: 8px;">
                <i class="icon-promo m-r-1 col-w"
                   style="font-size: 16px;"></i>
                <span class="p2 col-w m-r-1">{{couponCode}}</span>
                <button style="width: 18px; height: 18px;"
                        type="button"
                        (click)="remove()">
                    <i class="icon-close col-w"
                       style="font-size: 16px;"></i>
                </button>
            </div>
            }
        </div>
        }
        <div [grid]="app.client.sizeId > 0 ? 2 : 1"
             class="m-t"
             [gridRowGap]="'8px'"
             [gridColumnGap]="'16px'">
            <button [buttonStyle]
                    [gridColumn]="1"
                    (click)="submit()"
                    [status]="status">
                {{ 'apply' | translate}}
            </button>
            <button [buttonStyle]="'button-1'"
                    [gridColumn]="1"
                    (click)="cancel()">
                {{ 'cancel' | translate}}
            </button>
        </div>
    </form>
</basket-view-expandable>